import React, { ReactNode } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { DisplayFromValue } from '../../../shared/constants';

interface NavItemProps {
    children: ReactNode;
    displayFrom?: DisplayFromValue;
    dataTestId?: string;
}

export const NavItem = ({ children, displayFrom, dataTestId }: NavItemProps) => (
    <Container
        as="li"
        alignItems="center"
        display="flex"
        data-testid={dataTestId}
        hidden={{ default: false, ...(displayFrom && { default: true, [displayFrom]: false }) }}
    >
        {children}
    </Container>
);
